import { render, staticRenderFns } from "./scrappedmodal.vue?vue&type=template&id=40688298&scoped=true&"
import script from "./scrappedmodal.vue?vue&type=script&lang=js&"
export * from "./scrappedmodal.vue?vue&type=script&lang=js&"
import style0 from "./scrappedmodal.vue?vue&type=style&index=0&id=40688298&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40688298",
  null
  
)

export default component.exports